<div class="isav-map-container" #mapContainer></div>

<div class="message is-warning mt-3">
    <div class="message-body">
        Google maps can only be used to view terrarain, we do not display search related points and
        features on the map. Most of the features will be unavailable.
    </div>
</div>
